// extracted by mini-css-extract-plugin
export default {"activity":"Activity_activity__ADa7D","offset":"Activity_offset__ZqM5M"};